import styled from "styled-components/macro";
import { spacing } from "@material-ui/system";
import SearchIcon from "@material-ui/icons/Search";
import React, { FC, useState } from "react";
import { withStyles } from "@material-ui/styles";
import { TextField, Theme } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const SearchSpaced = styled.div(spacing);
const SearchContainer = styled(SearchSpaced)`
  display: flex;
  align-items: center;
  width: 28%;
  margin-right: 15px;
`
const IconContainer = styled.div`
  display:flex;
  padding: 7px 15px;
  cursor:pointer;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  background: linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);
`;
const SearchTextField = withStyles((theme: Theme) => ({
  root: {
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    },
    width: "100%",
    background: "#233145",
    borderRadius: "5px 0px 0px 5px",
    '& div': {
      border: "none",
      borderTopLeftRadius: "5px",
      borderBottomLeftRadius: "5px",
      borderRadius: 0,
    },
    '& .MuiOutlinedInput-notchedOutline ': {
      borderColor: "transparent"
    },
  }

}))(TextField);

type PropsType = {
  getText: (value: string) => void
}

const SearchBlock: FC<PropsType> = ({ getText }) => {
  const [value, setValue] = useState('')
  const { t } = useTranslation()

  return (
    <SearchContainer>
      <SearchTextField
        variant="outlined"
        id="search"
        size="small"
        value={value}
        onKeyDown={(e) => {
          if (e.key === 'Enter') getText(value)
        }}
        onChange={(e) => setValue(e.target.value)}
        placeholder={t('imagesPage_Search_by_name')} />
      <IconContainer onClick={() => getText(value)}>
        <SearchIcon style={{ color: "black" }} fontSize="default" />
      </IconContainer>
    </SearchContainer>
  )
}

export default SearchBlock
